import { schema } from 'normalizr';

export const ENTITY_REDUCER_KEY = 'files';

const entityDefinition = {};
const entityOptions = { idAttribute: 'uuid' };
export const entity = new schema.Entity(ENTITY_REDUCER_KEY, entityDefinition, entityOptions);
